


























import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { DataModules } from "@/store/modules/data";
@Component
export default class AdminClientsView extends Vue {
  // Props
  @Prop({ default: () => () => [] })
  public routes!: () => any;
  // Data
  public isLoading = true;
  public hasClients = false;

  public async mounted() {
    this.isLoading = true;
    // Here we get just ONE client to determine whether we need to show
    // onboarding messaging etc.
    this.hasClients = !!this.$_.get(
      await this.$store.dispatch(`data/${DataModules.CLIENTS}/list`, {
        params: {
          limit: 1
        },
        storeData: false,
        returnData: false
      }),
      "total",
      0
    );
    this.isLoading = false;
  }

  public get i18n() {
    return {
      add_client: this.$t("_action.add_object", {
        object: (this.$t("_.client") as string).toLowerCase()
      }),
      add_your_first_client: this.$t("_.add_your_first_object", {
        object: (this.$t("_.client") as string).toLowerCase()
      })
    };
  }
}
